import React, {useEffect, useState} from 'react';
import {
    DEFAULT_PAGE,
    DEFAULT_PAGE_SIZE,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY,
    ResponseCode
} from "@app/constants/Common";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestCandidates} from "@app/services/CandidateService";
import {alertMessage} from "@app/constants/Messages";
import {doExportExcel} from "@app/utils/CommonUtils";
import {
    requestInputBriefEmailDVTJCUV,
    requestInputEmailInviteDVTJCUV,
    requestMoveCddDVTJCUVToTab,
    requestRemoveCandidatesOutDVTJCUVTabs
} from "@pages/dvtjcuv/service/DVTJCUVService";
import {processRequestCheckDVTJCUVEmailBrief} from "@pages/dvtjcuv/rundvtjcuv/RunDVUtil";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";

const DVTJCUVSearchCddJobBriefEmailCandidateList = (props) => {
    const [currentTab, setCurrentTab] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [runJobInfo, setRunJobInfo] = useState({});

    const {runJob, parentTab, subTab, cddId, isPassLimitWeekOrMonth} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});

    console.log("parent tab:" + JSON.stringify(parentTab))
    console.log("sub tab:" + JSON.stringify(subTab))

    const fetchCandidateList = async (runJobData, pTab, sTab, page, isExportExcel, candidateIds=[]) => {
        const params = {page: page > 0 ? page : DEFAULT_PAGE,
            size: DEFAULT_PAGE_SIZE, order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                run_dvtjcuv_brief_email_mode: true,
                parent_tab: pTab ? pTab.id : "",
                sub_tab: sTab ? sTab.id : "",
                is_pass_limit_week_month: isPassLimitWeekOrMonth
            }
        }

        if (candidateIds && candidateIds.length > 0) {
            params.search_conditions.candidate_ids = candidateIds;
        }

        if (cddId) {
            params.search_conditions.search_job_cdd_id = cddId;
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        const res = await requestCandidates(params);
        if (isExportExcel) {
            doExportExcel(res.content.candidates)
        }
        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const onExportExcel = async (candidateIds) => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true, candidateIds)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const onSendEmailInviteJob = async (candidateIds) => {
        // let requestData = {run_job_id: runJobInfo.id, candidate_ids: candidateIds, job_id: runJobInfo.job_id}
        // await requestSendEmailInviteJob(requestData)
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const removeCandidateOutTabs = async (tabIds, candidateIds) => {
        let requestData = {run_dvtjcuv_id: runJobInfo.id,
            candidate_ids: candidateIds,
            parent_tab: parentTab.id,
            sub_tabs: tabIds,
        }
        await requestRemoveCandidatesOutDVTJCUVTabs(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const moveCandidatesToTab = async (currentTabId, nextTabId, candidateIds) => {
        let requestData = {
            run_dvtjcuv_id: runJobInfo.id,
            candidate_ids: candidateIds,
            from_parent_tab: parentTab.id,
            to_parent_tab: parentTab.id,
            from_sub_tab: currentTabId,
            to_sub_tab: nextTabId,
        }
        await requestMoveCddDVTJCUVToTab(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }


    const onInputBriefEmailInputDVTJCUV = async (receiverIds, inviteMode) => {
        const res = await requestInputBriefEmailDVTJCUV({
            candidate_id: cddId,
            receiver_ids: receiverIds,
            parent_tab: parentTab.id,
            sub_tab: subTab.id,
            invite_mode: inviteMode || EmailInviteMode.INVITE_BRIEF_EMAIL
        })

        // console.log("res:" + JSON.stringify(res))

        // alertMessage(res.sts_code, true, true)

        if (res.sts_code === ResponseCode.SUCCESS) {
            await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
        }
    }

    const onNextPage = async (page, searchOrderBy) => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, page)
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (subTab) {
            setCurrentTab({...subTab})
        }
        fetchCandidateList(runJob, parentTab, subTab)

    }, [runJob, parentTab, subTab]);

    const onStartCheckSendBriefEmailDVTJCUV = async (condition = {}) => {
        condition.candidate_id = cddId
        condition.receiver_ids = condition.receiver_ids || []
        const result = await processRequestCheckDVTJCUVEmailBrief(condition)
        if (result) {
            // onChangeTab(DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB)
            fetchCandidateList(runJob, parentTab, subTab)
        }
    }

    return (
        <>
            <CandidateListTable candidates={candidates}
                                allCandidateIds={allCandidateIds}
                                totalCount={totalCount}
                                showBtnSelect
                                onExportExcel={onExportExcel}
                                onSendBriefEmailDVTJCUV={onStartCheckSendBriefEmailDVTJCUV}
                                mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL}
                                mailInviteJobTab={currentTab}
                                parentTab={parentTab}
                                subTab={subTab}
                                removeCandidateOutTabs={removeCandidateOutTabs}
                                moveCandidatesToTab={moveCandidatesToTab}
                                onInputEmailInputDVTJCUV={onInputBriefEmailInputDVTJCUV}
                                onSearchCandidates={(page, searchOrderBy) => onNextPage(page, searchOrderBy)}
            />
        </>
    )
}

export default DVTJCUVSearchCddJobBriefEmailCandidateList;
